import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CommonMap } from 'client/tracking/maps/common';

const map = {
  select_loan_vehicle: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SELECT_LOAN_VEHICLE
  ),
  select_lease_vehicle: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SELECT_LEASE_VEHICLE
  ),
  select_affordability_vehicle: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SELECT_AFFORDABILITY_VEHICLE
  ),
  select_incentive_vehicle: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SELECT_INCENTIVE_VEHICLE
  ),
  select_maintenance_vehicle: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SELECT_MAINTENANCE_VEHICLE
  ),
  select_gas_guzzler_vehicle: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SELECT_GAS_GUZZLER_VEHICLE
  ),
  open_loan_calculator: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.OPEN_LOAN_CALCULATOR
  ),
  open_lease_calculator: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.OPEN_LEASE_CALCULATOR
  ),
  open_lease_vs_buy_calculator: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.OPEN_LEASE_VS_BUY_CALCULATOR
  ),
  open_affordability_calculator: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.OPEN_AFFORDABILITY_CALCULATOR
  ),
  open_incentive_calculator: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.OPEN_INCENTIVE_CALCULATOR
  ),
  open_gas_guzzler_calculator: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.OPEN_INCENTIVE_CALCULATOR
  ),
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};
